import { size } from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import TextInput from '../ReusableComponents/TextInput/TextInput';

const useStyles = makeStyles()((theme) => ({
  actions: {
    margin: '15px 0px',
    '& > button': {
      marginRight: theme.spacing(1),
    },
  },
  dialog: {},
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '300px',
    justifyContent: 'space-between',
    width: '300px',
  },
  dialogContentActions: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  root: {
    padding: '15px 0px',
  },
}));

export default function ApproveReject(props) {
  const { onReject, onApprove, disableApprove = false, record, title } = props;
  const { classes } = useStyles();
  const [open, setOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');

  return (
    <div className={classes.root}>
      <Typography variant="h5" gutterBottom>
        {`${title} Review`}
      </Typography>
      <Divider />
      <div className={classes.actions}>
        {!record.approved_by && (
          <Button
            color="primary"
            variant="outlined"
            size="large"
            disabled={disableApprove}
            onClick={() => onApprove(record.id)}
          >
            Approve
          </Button>
        )}
        <Button
          color="secondary"
          variant="outlined"
          size="large"
          onClick={() => setOpen(true)}
        >
          Reject
        </Button>
      </div>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Rejection Reason</DialogTitle>
        <DialogContent classes={{ root: classes.dialogContent }}>
          <TextInput
            id="rejection-modal-reason"
            value={rejectionReason}
            name="vendor_rejection_reason"
            onChange={(e) => setRejectionReason(e.target.value)}
            fullWidth
            label="Add A Rejection Reason"
          />

          <div className={classes.dialogContentActions}>
            <Button
              variant="contained"
              size="medium"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              size="medium"
              onClick={() =>
                onReject(record.id, {
                  rejection_reason: rejectionReason,
                  status: 'Rejected',
                })
              }
              disabled={!size(rejectionReason)}
            >
              Confirm
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

ApproveReject.propTypes = {
  onReject: PropTypes.func.isRequired,
  onApprove: PropTypes.func.isRequired,
  disableApprove: PropTypes.bool,
  record: PropTypes.shape({
    id: PropTypes.number,
    approved_by: PropTypes.number,
  }).isRequired,
  title: PropTypes.string.isRequired,
};
